import React from 'react'

import { ObservabilityToolAWSAuthenticationDetails } from 'components/status-checks/form/authentication/aws/ObservabilityToolAWSAuthenticationDetails'
import { ObservabilityToolCustomAuthenticationDetails } from 'components/status-checks/form/authentication/ObservabilityToolCustomAuthenticationDetails'
import { ObservabilityToolOtherAuthenticationDetails } from 'components/status-checks/form/authentication/ObservabilityToolOtherAuthenticationDetails'
import { ObservabilityToolPrometheusAuthenticationDetails } from 'components/status-checks/form/authentication/prometheus/ObservabilityToolPrometheusAuthenticationDetails'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const ObservabilityToolAuthenticationDetails = ({
  observabilityToolType
}) => {
  switch (observabilityToolType) {
    case ObservabilityToolType.CUSTOM:
      return <ObservabilityToolCustomAuthenticationDetails />
    case ObservabilityToolType.AWS:
      return <ObservabilityToolAWSAuthenticationDetails />
    case ObservabilityToolType.PROMETHEUS:
      return <ObservabilityToolPrometheusAuthenticationDetails />
    default:
      return <ObservabilityToolOtherAuthenticationDetails />
  }
}
